<template>
  <div id="main-dashboard">
    <div id="dashboard-container">
      <div id="dashboard-body">
        <div class="ui container dashboard-info">
          <div class="green-header"  style="position:relative">
            <span class="modal-title">{{ $t('views.secure.home.Jefes_equipo') }}</span>
          </div>
          <h3 class="ui dividing header">{{ $t("components.usersGroups.Listado_de_jefes_equipo") }}</h3>
          <div class="ui grid stackable main_container">
            <div class="sixteen wide column">
              <RegisteredUsersGroups></RegisteredUsersGroups>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import RegisteredUsersGroups from '@/components/RegisteredUsersGroups.vue';

export default {
  name: 'UsersGroups',
  components: {
    RegisteredUsersGroups
  },
  mounted: function () {
    $('.ui.sidebar').sidebar('hide');
  }
};
</script>
